export default __webpack_public_path__ + "static/mainpage-web-c119ca0c47b8d2583b27e7a312c0a521.png";